import * as actions from './constants';
import * as sectionActions from './../store/constants';
import adoptStats from '../adoptStats';


const defaultSeats = {
    map: null, //String <svg... 
    data: null,
    rainbow: null,
    general_admission: false,
    matrix: {},
}

const defaultState = {
    section: null, //Current sections, can not be null
    seats: defaultSeats,
    prices: null,
    loading: false,
    error: null
}

const getLevels = ({ rows }) => {
    const levels = {};
    rows.forEach(row => row.seats?.forEach(seat => {
        const price = parseFloat(seat.prices?.[0]?.actual_price_wfees);
        if (levels[price]) {
            levels[price]++;
        } else {
            levels[price] = 1;
        }
    }));
    return Object.keys(levels).sort((a, b) => levels[b] - levels[a]).map(p => parseFloat(p)).toReversed();
}

export default function(state = defaultState, action) {
    const { type, payload=null, error=null } = action;
    
    switch (type) {

        case sectionActions.EVENTBUY_SELECT_SECTION:
        case actions.RESET_SEATS: {
            return defaultState;
        }

        case actions.SET_SEATSMAP_MATRIX: {
            return {
                ...state,
                seats: {
                    ...state.seats,
                    matrix: {...payload}
                }
            }
        }

        case actions.FETCH_SEATSMAP_START: {
            return {
                ...state,
                section: payload,
                seats: defaultSeats,
                loading: true
            }
        }

        case actions.FETCH_SEATSMAP_SUCCESS: {

            const { map, stats, rows, general_admission = false } = payload;

            const { prices } = adoptStats(stats);

            const data = {};
            const rainbow = {};

            rows.forEach(row => {
                const seats = row?.seats;
                if (!data[row.name]) {
                    data[row.name] = {}
                }
                seats.forEach(seat => {
                    if (!seat?.can_reserve_attendee) {
                        return;
                    }
                    data[row.name][seat.name] = {price: seat?.can_reserve_attendee ? seat.prices?.[0]?.actual_price_wfees : undefined, color: seat.prices?.[0]?.color || '#4CB050'}
                    rainbow[seat.prices?.[0]?.color] = seat.prices?.[0]?.actual_price_wfees;
                });
            });

            const info = {
                ...defaultSeats,
                map,
                data,
                general_admission
            };

            const levels = getLevels({rows});

            return {
                ...state,
                prices: prices?.sort((a, b) => a - b).reverse(), //Decrement sorting (5040, 3050, 2080 ...)
                levels,
                rainbow,
                seats: info,
                loading: false,
                error: null
            }
        }

        case actions.FETCH_SEATSMAP_FAILURE: {
            return {
                ...defaultState,
                error
            }
        }

        default:
            return state;
    }
}